import styled from 'styled-components';
import PropTypes from 'prop-types';
import Portal from '@material-ui/core/Portal';

const ModalOverlay = styled.div`
  ${({ modalState }) =>
    modalState ? 'visibility: visible;' : 'visibility: hidden;'}
  display: block;
  position: fixed;
  z-index: 99999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0); /* Fallback color */
  transition: visibility 300ms ease;
  ${({ overlayTransparent }) =>
    overlayTransparent
      ? 'background-color: rgba(0, 0, 0, 0);'
      : 'background-color: rgba(0, 0, 0, 0.5);'}
`;

const ModalGrid = styled.div`
  width: 1136px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  grid-column-gap: 16px;
  position: absolute;
  left: 0;
  right: 0;
  transition: opacity 300ms ease, bottom 300ms ease;
  opacity: ${({ modalState }) => (modalState ? '1' : '0')};
  bottom: ${({ modalState, bottomFrom, bottomTo }) =>
    modalState ? bottomTo : bottomFrom};
  @media only screen and (max-width: 540px) {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
`;

const ModalContent = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.dropShadowV4};
  box-sizing: border-box;
  border-radius: 8px;
  grid-column: ${({ gridColumn }) => gridColumn || 'initial'};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

const CustomModal = ({
  children,
  modalState,
  onClose,
  overlayTransparent,
  gridColumn,
  bottomTo,
  bottomFrom
}) => {
  return (
    <Portal>
      <ModalOverlay
        overlayTransparent={overlayTransparent}
        modalState={modalState}
        onClick={() => {
          onClose();
        }}
      >
        <ModalGrid
          modalState={modalState}
          bottomTo={bottomTo}
          bottomFrom={bottomFrom}
        >
          <ModalContent
            gridColumn={gridColumn}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {children}
          </ModalContent>
        </ModalGrid>
      </ModalOverlay>
    </Portal>
  );
};

export default CustomModal;

CustomModal.propTypes = {
  children: PropTypes.node.isRequired,
  modalState: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  overlayTransparent: PropTypes.bool,
  gridColumn: PropTypes.string,
  bottomFrom: PropTypes.string,
  bottomTo: PropTypes.string
};

CustomModal.defaultProps = {
  overlayTransparent: false,
  gridColumn: null,
  bottomFrom: '0px',
  bottomTo: '0px'
};
